import { createSagaActionTypes } from '../../../utils/actionFactory';

export const GET_GROUPS = 'GET_GROUPS';
export const OPEN_EDIT = 'OPEN_EDIT';

export const actions = createSagaActionTypes('GROUPS', [GET_GROUPS, OPEN_EDIT]);
